'use client';

import { useState } from 'react';
import type { ProductDocument } from 'models/product';
import BaseModal from '../../../components/modals/BaseModal';
import { PlaceABidForm } from 'features/auctions/forms/PlaceABidForm';

type PlaceABidModalProps = {
  product: ProductDocument;
  isOpen: boolean;
  dismiss: () => void;
};

export default function PlaceABidModal({
  product,
  isOpen,
  dismiss,
}: PlaceABidModalProps) {
  const [currentStep, setCurrentStep] = useState(0);

  const handleBackButtonClick = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleDismiss = () => {
    setCurrentStep(0);
    dismiss();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={handleDismiss}
      className="w-[55rem]"
      title="Place Your Bid"
      onBackButtonClick={currentStep > 0 ? handleBackButtonClick : undefined}
    >
      <PlaceABidForm
        product={product}
        onSubmitSuccess={handleDismiss}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    </BaseModal>
  );
}
